import { render, staticRenderFns } from "./ActionBtn.vue?vue&type=template&id=defe15b2&scoped=true"
import script from "./ActionBtn.vue?vue&type=script&lang=js"
export * from "./ActionBtn.vue?vue&type=script&lang=js"
import style0 from "./ActionBtn.vue?vue&type=style&index=0&id=defe15b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "defe15b2",
  null
  
)

export default component.exports